import { COLORS } from '@btime/constants'
import React from 'react'

import Container from '../../components/structure/Container'
import FullPageTemplate from '../../components/templates/FullPageTemplate'
import HeaderBar from './HeaderBar'
import ProjectsSection from './projects/ProjectsSection'
import Separator from '../../packages/kiti/components/helpers/Separator'
import SingleProjectChecker from './SingleProjectChecker'
import WelcomeBar from './WelcomeBar'

const HomePage = props => {
  return (
    <SingleProjectChecker>
      <FullPageTemplate bgColor={COLORS.white}>
        <div>
          <HeaderBar />

          <Container maxWidth="64rem">
            <Separator weight={12} />
            <WelcomeBar />
            <Separator weight={12} />

            <ProjectsSection />
          </Container>
        </div>
      </FullPageTemplate>
    </SingleProjectChecker>
  )
}

export default HomePage
